import React, { useState, useEffect } from "react";
import axios from "axios";
import "./DispatchPage.css"; // Make sure to create this CSS file
import NewEntryModal from "./NewEntryModal";
import { FaCopy } from "react-icons/fa";
import { useAuth } from "../AuthContext";

const DispatchPage = () => {
  const [dispatchEntries, setDispatchEntries] = useState([]);
  const [showNewEntryModal, setShowNewEntryModal] = useState(false);

  const [customers, setCustomers] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const { mobile } = useAuth();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);

  // Handler to update search term state
  const handleSearchChange = async (e) => {
    const searchTerm = e.target.value.toLowerCase();
    setSearchTerm(searchTerm);

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/dispatch`,
        { params: { search: searchTerm } }
      );
      const sortedEntries = response.data.sort(
        (a, b) => new Date(b.date_of_dispatch) - new Date(a.date_of_dispatch)
      );
      setDispatchEntries(sortedEntries);
    } catch (error) {
      console.error("Failed to fetch dispatch entries", error);
      setError("Failed to load dispatch entries.");
    }
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      // if (!initialLoadComplete) {
      //   setIsLoading(true);
      // }
      setError("");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/customers-names`
        );
        setCustomers(response.data);
      } catch (error) {
        console.error("Failed to fetch customers", error);
        setError("Failed to load customer data.");
      } finally {
        // setIsLoading(false);
        // setInitialLoadComplete(true);
      }
    };
    const fetchDispatchEntries = async (searchTerm = "") => {
      setError("");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/dispatch`,
          { params: { search: searchTerm } }
        );
        const sortedEntries = response.data.sort(
          (a, b) => new Date(b.date_of_dispatch) - new Date(a.date_of_dispatch)
        );
        setDispatchEntries(sortedEntries);
      } catch (error) {
        console.error("Failed to fetch dispatch entries", error);
        setError("Failed to load dispatch entries.");
      }
    };

    fetchDispatchEntries(); // Fetch the latest 1000 entries initially
    fetchCustomers();
  }, []);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        console.log("Copy successful");
        setPopupMessage("Dispatch Details Copied to clipboard!");
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
      },
      (err) => {
        console.error("Error copying text: ", err);
        setPopupMessage("Dispatch Details Failed to copy!");
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
      }
    );
  };

  const handleNewEntrySubmit = async (entryData) => {
    // Function to submit a new dispatch entry to the backend
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/dispatch`,
        entryData
      );
      setShowNewEntryModal(false);
      // Refresh the list of dispatch entries
      // This could also be done by appending the new entry to the dispatchEntries state,
      // but fetching again will ensure the list is fully up to date.
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/dispatch`
      );
      setDispatchEntries(response.data);
      setPopupMessage("Dispatch Entry Successful!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000); // Hide popup after 3 seconds
    } catch (error) {
      console.error("Failed to submit new dispatch entry", error);
    }
  };

  const formatDispatchDetails = (entry) => {
    return (
      `*Dispatch Details*\n\n` +
      `*Party Name*: ${entry.party_name}\n\n` +
      `*Invoice Number*: ${entry.invoice}\n\n` +
      // Add more fields as necessary
      `*Date of Dispatch*: ${formatDate(entry.date_of_dispatch)}\n\n` +
      `*Mode of Transport*: ${entry.mode_of_transport}\n\n` +
      `*Transport / Courier Name*: ${entry.transport_courier_name}\n\n` +
      `*Docket / GR No*: ${entry.docket_gr_no}\n\n` +
      `*Value of Goods*: ${entry.value_of_goods}/-\n\n` +
      `*No. of Cases*: ${entry.no_of_cases}`
    );
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const filteredEntries = dispatchEntries;

  const renderEntriesTable = () => (
    <table>
      <thead>
        <tr>
          <th>Party Name</th>
          <th>Invoice Number</th>
          <th>Date of Dispatch</th>
          <th>Mode of Transport</th>
          <th>Transport / Courier Name</th>
          <th>Docket / GR</th>
          {mobile === "9216744110" && <th>Value of Goods</th>}
          <th>No. of Cases</th>
          <th>Image</th>
          <th>Copy</th>
        </tr>
      </thead>
      <tbody>
        {filteredEntries.map((entry) => (
          <tr key={entry.id}>
            <td style={{ textAlign: "center" }}>{entry.party_name}</td>
            <td style={{ textAlign: "center" }}>{entry.invoice}</td>
            <td style={{ textAlign: "center" }}>
              {formatDate(entry.date_of_dispatch)}
            </td>
            <td style={{ textAlign: "center" }}>{entry.mode_of_transport}</td>
            <td style={{ textAlign: "center" }}>
              {entry.transport_courier_name}
            </td>
            <td style={{ textAlign: "center" }}>{entry.docket_gr_no}</td>
            {mobile === "9216744110" && (
              <td style={{ textAlign: "center" }}>{entry.value_of_goods}/-</td>
            )}
            <td style={{ textAlign: "center" }}>{entry.no_of_cases}</td>
            <td style={{ textAlign: "center" }}>
              {entry.image_of_builty ? (
                <a
                  href={
                    "https://www.trumachealthcare.net/apiwha/dispatch-builtys/" +
                    entry.image_of_builty
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Image
                </a>
              ) : (
                "No Image"
              )}
            </td>
            <td style={{ textAlign: "center" }}>
              <FaCopy
                style={{ cursor: "pointer" }}
                onClick={() => copyToClipboard(formatDispatchDetails(entry))}
                title="Copy to clipboard"
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div className="dispatch-page">
      {/* {isLoading && (
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>} */}
      {showPopup && <div className="popup-message">{popupMessage}</div>}
      {/* {!isLoading && !error && (
        <> */}
      <div className="top-bar">
        <input
          type="text"
          placeholder="Search..."
          onChange={handleSearchChange}
          className="search-bar"
        />
        {mobile === "9216744110" && (
          <button onClick={() => setShowNewEntryModal(true)}>New Entry</button>
        )}
      </div>
      {renderEntriesTable()}
      {showNewEntryModal && (
        <NewEntryModal
          customers={customers}
          onSubmit={handleNewEntrySubmit}
          onClose={() => setShowNewEntryModal(false)}
        />
      )}
      {/* </>
      )} */}
    </div>
  );
};

export default DispatchPage;
